import {constants, mediaQueryStyles} from '@newsela/angelou';
import {css} from 'emotion';


const mq = mediaQueryStyles.mediaQuery;
const greyDark = constants.colors.ui.greyDark[500];
const green = constants.colors.ui.green[700];

const suggestion = css`
  box-sizing: border-box;
  cursor: pointer;
  left: 50%;
  list-style-type: none;
  margin: 0 0;
  max-width: 840px;
  padding: 17px;
  position: relative;
  transform: translateX(-50%);
  /**
   * Width of suggestion should be slightly wider so that text stays aligned
   * with other list items but blue background highlight maintains side
   * padding
   */
  width: 110%;
  &:hover, &:focus {
    background-color: #ecf3ff;
    color: ${greyDark};
    cursor: pointer;
    outline: none;

    h4 {
      text-decoration: underline;
    }
  }

  ${mq.between(500, 830)} {
    width: 100%;
    margin: 0;
    padding: 17px 0;
  }
`;

const descriptionRow = css`
  align-content: flex-start;
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: space-between;
  margin-bottom: 8px;
  padding: 0 5px;
  width: 100%;


  ${mq.downTo('sm')} {
    flex-direction: row;
  }
`;

const title = css`
  align-self: auto;
  color: ${green};
  flex: 0 1 auto;
  font-size: 1.31em;
  font-weight: bold;
  height: auto;
  line-height: 1;
  margin: 0;
  min-width: 136px;
  order: 0;
  width: 100%;

  &:nth-child(2) {
    margin-top: 40px;
  }
`;

const text = css`
  color: ${greyDark};
  font-size: 1.31em;
  font-weight: 300;
  height: auto;
  line-height: 27px;
  margin: 0 0;
  padding: 0 5px;
  width: 100%;
`;

const grade = css`
  align-self: auto;
  color: ${greyDark};
  flex: 0 1 auto;
  font-size: 1.31em;
  font-weight: 300;
  height: auto;
  line-height: 27px;
  margin-top: 10px;
  order: 0;
  padding: 0;
  text-align: left;
  width: 100%;

  ${mq.downTo('sm')} {
    display: block;
    padding: 0 0 5px;
    margin: 0;
    text-align: right;
    width: 50%;
  }
`;

export default {
  suggestion,
  descriptionRow,
  title,
  grade,
  text,
};
